import axios from 'axios';
import api from '@src/api';

export const state = {
  equipmentTypes: [],
};

export const getters = {
  equipmentTypeNameMap: (state) => {
    const map = {};
    if (state.equipmentTypes) {
      state.equipmentTypes.forEach((equipmentType) => {
        map[equipmentType.name] = equipmentType;
      });
    }
    return map;
  },
  equipmentTypeIdMap: (state) => {
    const map = {};
    if (state.equipmentTypes) {
      state.equipmentTypes.forEach((equipmentType) => {
        map[equipmentType._id] = equipmentType;
      });
    }
    return map;
  },
};

export const mutations = {
  setEquipmentTypes(state, newValue) {
    state.equipmentTypes = newValue.equipmentType;
  },
};

export const actions = {
  getEquipmentTypes(ctx, { orgId, trainerId }) {
    const url = api.URL_GET_ALL_EQUIPMENT_TYPES.replace(
      ':orgID',
      orgId
    ).replace(':trainerID', trainerId);

    return axios
      .get(url)
      .then((res) => {
        if (res) {
          ctx.commit('setEquipmentTypes', res.data);
          return res.data;
        }
      })
      .catch((err) => console.warn(err));
  },
};
